import React from 'react';
import {
  Compass, Cpu, Palette, Megaphone, Bot, Sparkles, Search, Users,
  Target, PenTool, BarChart3, TrendingUp,
  Globe, Activity, ShieldAlert, FileText, GitBranch, Map, Layout, Microscope,
  Edit3, Zap, Briefcase, AlertTriangle, Presentation, Code, GitPullRequest, Heart,
  Rocket, Crosshair, Package, Landmark, Flame, LineChart, Sigma, PieChart,
  GraduationCap, Timer, CalendarClock, HelpCircle,
  Clapperboard, Image as ImageIcon, Music, Mic, Camera, Wand2, AudioWaveform,
  HeartPulse, Dumbbell, Salad, Wallet, PiggyBank, Coins,
  Scale, FileSignature, ShieldCheck, Gavel, Film, Contact, Speech, Network,
  Kanban, Figma, ClipboardList, ChefHat, Utensils, Home,
  Plane, Route, MapPin, ListChecks, Flag, Leaf,
  type LucideIcon,
} from 'lucide-react';

// Maps a profile's avatar_icon (lowercase name) to a Lucide icon. Falls back to Bot.
const ICONS: Record<string, LucideIcon> = {
  // markets & macro
  globe: Globe, activity: Activity, 'bar-chart-3': BarChart3, 'shield-alert': ShieldAlert,
  'file-text': FileText, 'git-branch': GitBranch,
  // creative / sci-fi
  map: Map, layout: Layout, microscope: Microscope, 'edit-3': Edit3,
  // marketing
  target: Target, 'pen-tool': PenTool, palette: Palette, zap: Zap, 'trending-up': TrendingUp,
  // research & consulting
  search: Search, briefcase: Briefcase, 'alert-triangle': AlertTriangle, presentation: Presentation,
  // engineering
  code: Code, 'git-pull-request': GitPullRequest,
  // lifestyle
  heart: Heart, sparkles: Sparkles, users: Users,
  // startup & founders
  rocket: Rocket, crosshair: Crosshair, package: Package, landmark: Landmark, flame: Flame,
  // data science & ai
  'line-chart': LineChart, cpu: Cpu, sigma: Sigma, 'pie-chart': PieChart,
  // study & learning
  'graduation-cap': GraduationCap, timer: Timer, 'calendar-clock': CalendarClock, 'help-circle': HelpCircle,
  // media studio
  clapperboard: Clapperboard, image: ImageIcon, music: Music, mic: Mic, camera: Camera,
  'wand-2': Wand2, 'audio-waveform': AudioWaveform,
  // health & wellness
  'heart-pulse': HeartPulse, dumbbell: Dumbbell, salad: Salad,
  // personal finance
  wallet: Wallet, 'piggy-bank': PiggyBank, coins: Coins,
  // legal
  scale: Scale, 'file-signature': FileSignature, 'shield-check': ShieldCheck, gavel: Gavel, film: Film,
  // career & job search
  contact: Contact, speech: Speech, network: Network,
  // product & design
  kanban: Kanban, figma: Figma, 'clipboard-list': ClipboardList,
  // cooking & home
  'chef-hat': ChefHat, utensils: Utensils, home: Home,
  // travel
  plane: Plane, route: Route, 'map-pin': MapPin,
  // coaching & productivity
  'list-checks': ListChecks, flag: Flag, leaf: Leaf,
  // legacy / generic
  compass: Compass, telescope: Search, megaphone: Megaphone,
};

export const SpecialistIcon: React.FC<{ name?: string; className?: string }> = ({ name, className }) => {
  const Icon = (name && ICONS[name.toLowerCase()]) || Bot;
  return <Icon className={className} />;
};
